import { getHost } from './hostDataFunction';
import { HIDE_FILTER_DOMAINS } from '../constants/appConstants';

export const formatSayHelloCourseDropdownOptions = (courses: { name: string; id: number }[] = []) => {
  return courses.map((course) => ({
    label: course?.name,
    value: course?.id,
  }));
};

export function showBuddyFilters(): boolean {
  const host = getHost() ?? '';

  return !HIDE_FILTER_DOMAINS.includes(host);
}
